export default __webpack_public_path__ + "83ab90aff62e3dc01b45bd81616149c2.svg";